import { render, staticRenderFns } from "./NuevoPlanMedico.vue?vue&type=template&id=10238263&"
import script from "./NuevoPlanMedico.vue?vue&type=script&lang=js&"
export * from "./NuevoPlanMedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports